import React from 'react';
import { Link } from 'react-router-dom';
import { useLanguage } from '../../context/LanguageContext';

export const Header = () => {
  const { lang, t, toggleLanguage } = useLanguage();

  return (
    <header className="header" role="banner">
      <div className="header-inner">
        <Link to={lang === 'ar' ? '/ar' : '/'} className="header-logo" aria-label={t.logoAlt}>
          <img src="/assets/helpdesk/logo.svg" alt={t.logoAlt} width="112" height="40" />
        </Link>

        <button
          type="button"
          onClick={toggleLanguage}
          className="lang-switcher"
          aria-label={`Switch to ${t.langLabel}`}
        >
          <svg
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            aria-hidden="true"
          >
            <circle cx="12" cy="12" r="10" />
            <path d="M2 12h20M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z" />
          </svg>
          <span>{t.langLabel}</span>
        </button>
      </div>
    </header>
  );
};

export default Header;
